import React from 'react'
import '../App.css'
import Bodygestionminutas from './bodygestionminutas'
export class Bodyappgestionminutasbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='w-full'>
                <Bodygestionminutas/>
            </div>
            
        );
    }
}